import { render, staticRenderFns } from "./IncomeTable.vue?vue&type=template&id=18df8ecc&scoped=true&"
import script from "./IncomeTable.vue?vue&type=script&lang=js&"
export * from "./IncomeTable.vue?vue&type=script&lang=js&"
import style0 from "./IncomeTable.vue?vue&type=style&index=0&id=18df8ecc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18df8ecc",
  null
  
)

export default component.exports